import { RouteNames } from '@/router/routeNames';
import MyAccount from './MyAccount.vue';
import type { RouteRecordRaw } from 'vue-router';

const route: RouteRecordRaw = {
  name: RouteNames.MY_ACCOUNT,
  path: 'account',
  component: MyAccount,
  meta: {
    pageTitle: 'Landing.AccountSettings',
  },
};

export default route;
